import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
} from "@material-ui/core";
import styles from "./RxOrderDetail.module.css";

export interface ProductDetail {
	name: string;
	quantity: number;
	itemTotalPrice: number;
}

interface RxOrderDetailProps {
	tableClassName?: string;
	tableHeadClassName?: string;
	values: ProductDetail[];
	totalPrice: number;
}
const RxOrderDetail = (props: RxOrderDetailProps) => {
	return (
		<Table className={props.tableClassName}>
			<TableHead className={props.tableHeadClassName}>
				<TableRow>
					<TableCell className={styles.bold}>Ürün</TableCell>
					<TableCell className={styles.bold} align="right">
						Miktar
					</TableCell>
					<TableCell className={styles.bold} align="right">
						Tutar
					</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{props.values.map((item: ProductDetail) => {
					return (
						<TableRow>
							<TableCell>{item.name}</TableCell>
							<TableCell align="right">{item.quantity}</TableCell>
							<TableCell align="right">
								{item.itemTotalPrice.toFixed(2) + " TL"}
							</TableCell>
						</TableRow>
					);
				})}
				<TableRow className={props.tableHeadClassName}>
					<TableCell className={styles.bold} align="right">
						Toplam:
					</TableCell>

					<TableCell className={styles.bold} align="right">
						{props.values.reduce((sum, item) => sum + item.quantity, 0) ??
							0}
					</TableCell>
					<TableCell className={styles.bold} align="right">
						{props.totalPrice.toFixed(2) + " TL"}
					</TableCell>
				</TableRow>
			</TableBody>
		</Table>
	);
};
export default RxOrderDetail;
